import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PremiumOverlay extends Vue {
  @Prop({ required: true }) readonly isPremium!: boolean;
}
